import { SignIn, useAuth } from "@clerk/clerk-react";

interface AuthGateProps {
  children: React.ReactNode;
}

/**
 * Blocks rendering until the user is authenticated.
 * Shows a centered sign-in card on first visit or after logout.
 */
export function AuthGate({ children }: AuthGateProps) {
  const { isLoaded, isSignedIn } = useAuth();

  // Clerk is still loading user state
  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center bg-[var(--bg-primary)]">
        <div className="w-6 h-6 border-2 border-[var(--accent)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Not signed in — show the sign-in form
  if (!isSignedIn) {
    return (
      <div className="flex h-screen items-center justify-center bg-[var(--bg-primary)]">
        <div className="flex flex-col items-center gap-6">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[var(--accent)] flex items-center justify-center">
              <span className="text-white text-sm font-bold">CW</span>
            </div>
            <div>
              <h1 className="text-[var(--text-primary)] text-xl font-semibold">CoWork</h1>
              <p className="text-[var(--text-secondary)] text-sm">Legal & CRE AI Platform</p>
            </div>
          </div>
          <SignIn routing="hash" />
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
